import React from "react";
import styled from "styled-components";
import Box from "../Box";
import {
  Colors,
  EVENT_DEEP_LINK_TYPE,
  MERCHANT_STATUS,
  OUTLET_TYPES,
  Text,
} from "../../config/Constants";
import Textfield from "../Merchant/Textfield";
import Selectfield from "../Merchant/Selectfield";
import Button from "../Button";
import Datefield from "./Datefield";
import Timefield from "./Timefield";
import UploadFile from "./UploadFile";
import Checkbox from "../Checkbox";
import TimeRangeSelector from "../TimeRange";
import { getWeekArray } from "../../helper";

interface Props {
  onSubmit: () => void;
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  parks: any;
  onCancel: () => void;
  onRemove: () => void;
  value: {
    title: string;
    description: string;
    location: string;
    // time: string;
    whatsapp: string;
    phone: string;
    imageUrl: string;
    date: string;
    endDate: string;
    // endTime: string;
    isInactive: string;
    deepLinkId: string;
    deepLinkType: string;
  };
  error: {
    title: string;
    description: string;
    location: string;
    whatsapp: string;
    phone: string;
    imageUrl: string;
    date: string;
    endDate: string;
    isInactive: string;
    deepLinkType: string;
    deepLinkId: string;
    time: any;
    timeType: string;
    timeSingle: string;
  };
  uploadedImage: any;
  outlets: (
    | { label: string; value: string }
    | { label: string; value: number }
  )[];
  isNotificationEnabled: boolean;
  setIsNotificationEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  isCheckboxDisabled: boolean;
  disabled: boolean;
  onTimeSelect: any;
  time: any;
  timeType: any;
  timeSingle: any;
  onPromoTimeChange: any;
}

const CreateEventFormContainer = ({
  onSubmit,
  onCancel,
  onChange,
  onRemove,
  value,
  error,
  uploadedImage,
  isNotificationEnabled,
  setIsNotificationEnabled,
  isCheckboxDisabled,
  parks,
  disabled,
  onTimeSelect,
  onPromoTimeChange,
  time,
  timeSingle,
  timeType,
}: Props) => {
  let selectedDateWeekArray = getWeekArray(value.date, value.endDate);

  const onTimeChange = (event: any, value: any, name: string) => {
    const newTime = value.replace(/-/g, ":");
    const timeVal = newTime.substr(0, 5);
    onTimeSelect(timeVal, event.target.name, name);
  };
  return (
    <Container>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="title"
                label="Event Title"
                placeholder="Enter event title "
                onChange={onChange}
                value={value.title}
                required
                helperText={error["title"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="location"
                label="Location"
                placeholder="Enter event location "
                onChange={onChange}
                value={value.location}
                required
                helperText={error["location"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Datefield
                name="date"
                label="Event Start Date"
                onChange={onChange}
                placeholder="Select Event date"
                value={value.date}
                required
                helperText={error["date"]}
              />
            </FieldWrapper>

            <FieldWrapper>
              <Datefield
                name="endDate"
                label="Event End Date"
                onChange={onChange}
                placeholder="Select Event date"
                value={value.endDate}
                helperText={error["endDate"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="phone"
                label="Contact"
                placeholder="+974XXXXXXXX"
                onChange={onChange}
                value={value.phone}
                helperText={error["phone"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="whatsapp"
                label="Whatsapp Number"
                onChange={onChange}
                placeholder="+974XXXXXXXX"
                value={value.whatsapp}
                helperText={error["whatsapp"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="deepLinkType"
                label="Deep Link Type"
                onChange={onChange}
                value={value.deepLinkType}
                required
                helperText={error["deepLinkType"]}
                data={EVENT_DEEP_LINK_TYPE}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="deepLinkId"
                label="Deep Link Outlet"
                onChange={onChange}
                value={value.deepLinkId}
                required
                helperText={error["deepLinkId"]}
                data={parks}
                disabled={value.deepLinkType !== "parks"}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="isInactive"
                label="Status"
                onChange={onChange}
                data={MERCHANT_STATUS}
                required
                value={value.isInactive}
                helperText={error["isInactive"]}
                disabled={false}
              />{" "}
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="description"
                label="Event Information"
                placeholder="Describe event"
                onChange={onChange}
                value={value.description}
                required
                helperText={error["description"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <UploadFile
                name="imageUrl"
                label="Upload your image"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["imageUrl"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <div style={{ marginTop: "1.5rem" }}>
                <Checkbox
                  label="Send Push Notification"
                  isChecked={isNotificationEnabled}
                  value="isNotificationEnabled"
                  onChange={(value) => {
                    setIsNotificationEnabled(!isNotificationEnabled);
                  }}
                  disabled={isCheckboxDisabled}
                />
                <CheckboxSub>{Text.checkboxSub}</CheckboxSub>
              </div>
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="type"
                label="Type Event Timings"
                onChange={onPromoTimeChange}
                value={timeType}
                required
                helperText={error["timeType"]}
                data={[
                  { label: "Select Timing", value: "" },
                  { label: "Single Time", value: "single" },
                  { label: "Multi Time", value: "multi" },
                ]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TimeRangeSelector
                name="timeSingle"
                label="Sun to Sat"
                placeholder="Sun to Sat"
                onTimeChange={(e, val) => onTimeChange(e, val, "timeSingle")}
                value={timeType === "multi" ? "" : timeSingle}
                required={timeType === "single"}
                disabled={!timeType || timeType === "multi"}
                helperText={error["timeSingle"]}
                fullWidth
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <TimeWrapper>
              <TimeRangeSelector
                name="mon"
                label="Mon"
                placeholder="Monday"
                onTimeChange={(e, val) => onTimeChange(e, val, "mon")}
                value={
                  selectedDateWeekArray.indexOf("mon") < 0 ? "" : time["mon"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("mon") < 0
                }
                helperText={error?.time["mon"]}
              />
              <TimeRangeSelector
                name="tue"
                label="Tue"
                placeholder="Tuesday"
                onTimeChange={(e, val) => onTimeChange(e, val, "tue")}
                value={
                  selectedDateWeekArray.indexOf("tue") < 0 ? "" : time["tue"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("tue") < 0
                }
                helperText={error?.time["tue"]}
              />
              <TimeRangeSelector
                name="wed"
                label="Wed"
                placeholder="Wednesday"
                onTimeChange={(e, val) => onTimeChange(e, val, "wed")}
                value={
                  selectedDateWeekArray.indexOf("wed") < 0 ? "" : time["wed"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("wed") < 0
                }
                helperText={error?.time["wed"]}
              />
              <TimeRangeSelector
                name="thu"
                label="Thu"
                placeholder="Thursday"
                onTimeChange={(e, val) => onTimeChange(e, val, "thu")}
                value={
                  selectedDateWeekArray.indexOf("thu") < 0 ? "" : time["thu"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("thu") < 0
                }
                helperText={error?.time["thu"]}
              />
              <TimeRangeSelector
                name="fri"
                label="Fri"
                placeholder="Friday"
                onTimeChange={(e, val) => onTimeChange(e, val, "fri")}
                value={
                  selectedDateWeekArray.indexOf("fri") < 0 ? "" : time["fri"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("fri") < 0
                }
                helperText={error?.time["fri"]}
              />
              <TimeRangeSelector
                name="sat"
                label="Sat"
                placeholder="Saturday"
                onTimeChange={(e, val) => onTimeChange(e, val, "sat")}
                value={
                  selectedDateWeekArray.indexOf("sat") < 0 ? "" : time["sat"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("sat") < 0
                }
                helperText={error?.time["sat"]}
              />
              <TimeRangeSelector
                name="sun"
                label="Sun"
                placeholder="Sunday"
                onTimeChange={(e, val) => onTimeChange(e, val, "sun")}
                value={
                  selectedDateWeekArray.indexOf("sun") < 0 ? "" : time["sun"]
                }
                required={false}
                disabled={
                  !timeType ||
                  timeType === "single" ||
                  selectedDateWeekArray.indexOf("sun") < 0
                }
                helperText={error?.time["sun"]}
              />
            </TimeWrapper>
          </FormRow>
          <ActionRow>
            <ButtonWrapper>
              <Button
                variant="outlined"
                label="Cancel"
                onClick={onCancel}
                width="9.7rem"
              />
              <Button
                color={Colors.red}
                variant="filled"
                label="Save"
                onClick={onSubmit}
                width="9.7rem"
                disabled={disabled}
              />
            </ButtonWrapper>
          </ActionRow>
        </FormWrapper>
      </Box>
    </Container>
  );
};

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const TimeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex: 1;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Container = styled.div`
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;
const CheckboxSub = styled.div`
  font-family: "Poppins-Medium";
  font-size: 0.6875rem;
  color: ${Colors.comet};
  opacity: 0.4;
  margin-left: 1.5rem;
`;

export default CreateEventFormContainer;
